module.exports = {"en":{"modules":{"stampcard":{"title":"Stamp Card","card":{"action":"Get a Gift!"},"popup":{"title":"Get a Gift"}}}}}